export function createFormElement(elementType, className, labelText) {
  const element = $('<' + elementType + '>');
  if (className) element.addClass(className);
  if (labelText) element.text(labelText);
  
  return element;
}

export default createFormElement;
